const isPgaLink = (url) => {
  if (!url) return true

  const bookingUrl = new URL(url)
  return bookingUrl.hostname && /\.pga\.com/i.test(bookingUrl.hostname)
}

export default isPgaLink
